import clsx from 'clsx';

import CloseIcon from '~/shared/assets/icons/arrow-right.svg';
import DeleteIcon from '~/shared/assets/icons/delete.svg';
import Typography from '~/shared/components/Typography';

import Button from '../ButtonsV2';

interface FilterPanelHeaderProps {
  onClose?: () => void;
  onClearAll?: () => void;
  hasActiveFilters?: boolean;
  clearAllText?: string;
  className?: string;
}

export default function FilterPanelHeader({
  onClose,
  onClearAll,
  hasActiveFilters = false,
  clearAllText = 'Clear All',
  className,
}: FilterPanelHeaderProps) {
  return (
    <div className={clsx('flex justify-between items-center px-6 py-6', className)}>
      <Typography
        variant="H3-resp"
        fontWeight={500}
        className="font-family-outfit text-primary-900"
      >
        Filters
      </Typography>
      <div className="flex items-center gap-2.5">
        {onClearAll && (
          <Button
            className="hover:!borderred group px-4 py-2"
            variant="text"
            size="sm"
            leftIcon={
              <DeleteIcon className="size-5 group-hover:textred transition-colors duration-300" />
            }
            onClick={onClearAll}
            disabled={!hasActiveFilters}
            aria-label="Clear All filters"
          >
            <span className="font-family-inter pt-0.5 block">{clearAllText || 'Clear All'}</span>
          </Button>
        )}
        {onClose && (
          <Button
            size="sm"
            className="w-9"
            variant="third"
            icon={<CloseIcon className="size-4.5" />}
            onClick={onClose}
          />
        )}
      </div>
    </div>
  );
}
